import React from "react";
import styled from "styled-components";
import AppHeader from "./AppHeader";
import { MdEmail, MdPhone, MdLocationOn, MdPerson, MdBusiness } from "react-icons/md";

const PageContainer = styled.div`
  background-color: #f8f9fa;
  min-height: 100vh;
  padding-bottom: 50px;
`;

const ContentWrapper = styled.div`
  max-width: 800px;
  margin: 30px auto;
  padding: 40px;
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  color: #2d3748;
`;

const Title = styled.h1`
  color: #1a202c;
  font-size: 2rem;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  gap: 10px;
`;

const Subtitle = styled.p`
  color: #718096;
  font-size: 16px;
  line-height: 1.6;
  margin-bottom: 30px;
  border-left: 4px solid #1a73e8;
  padding-left: 15px;
`;

const ContactGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-top: 20px;

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

const ContactCard = styled.div`
  padding: 20px;
  background: #fdfdfd;
  border: 1px solid #edf2f7;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;

  svg {
    color: #1a73e8;
    margin-bottom: 5px;
  }

  strong {
    font-size: 14px;
    color: #718096;
    text-transform: uppercase;
  }

  span, a {
    font-size: 16px;
    color: #2d3748;
    text-decoration: none;
    font-weight: 500;
  }
`;

const AddressCard = styled(ContactCard)`
  grid-column: span 2;
  @media (max-width: 600px) {
    grid-column: span 1;
  }
`;

const ContactUs = () => {
  return (
    <PageContainer>
      <AppHeader />
      <ContentWrapper>
        <Title><MdBusiness color="#1a73e8"/> Contact & Grievance Redressal</Title>
        <Subtitle>
          In compliance with Indian IT laws, for any queries or complaints, please reach out to our team:
        </Subtitle>

        <ContactGrid>
          <ContactCard>
            <MdPerson size={24}/>
            <strong>Grievance Officer</strong>
            <span>R. Uthandaraman</span>
          </ContactCard>

          <ContactCard>
            <MdBusiness size={24}/>
            <strong>Entity Name</strong>
            <span>Avaami Technologies Pvt. Ltd.</span>
          </ContactCard>

          <ContactCard>
            <MdPhone size={24}/>
            <strong>Mobile</strong>
            <a href="tel:+919944778818">+91 9944778818</a>
          </ContactCard>

          <ContactCard>
            <MdEmail size={24}/>
            <strong>Email</strong>
            <a href="mailto:support@avaami.com">support@avaami.com</a>
          </ContactCard>

          <AddressCard>
            <MdLocationOn size={24}/>
            <strong>Registered Address</strong>
            <span>
              No. 17/1, Sokkan Urani Street, Kovilpatti, <br/>
              Thoothukudi, Tamil Nadu - 628 502
            </span>
          </AddressCard>
        </ContactGrid>
      </ContentWrapper>
    </PageContainer>
  );
};

export default ContactUs;